const initializedPricing = new WeakSet();

export const initPublicPricing = (root = document) => {
  root.querySelectorAll('[data-public-pricing]').forEach((section) => {
    if (initializedPricing.has(section)) return;
    initializedPricing.add(section);
    const buttons = [...section.querySelectorAll('[data-pricing-cadence]')];
    const select = (cadence) => {
      buttons.forEach((button) => {
        const selected = button.dataset.pricingCadence === cadence;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('bg-brand-900', selected);
        button.classList.toggle('text-white', selected);
        button.classList.toggle('text-brand-900', !selected);
      });
      section.querySelectorAll('[data-pricing-price-cadence]').forEach((price) => {
        price.hidden = !['any', cadence].includes(price.dataset.pricingPriceCadence);
      });
    };
    buttons.forEach((button) => button.addEventListener('click', () => select(button.dataset.pricingCadence)));
    select('month');
  });
};
